// Oylan stand: Firebase logging is disabled (ENABLE_FIREBASE = false), no project is configured.
const config = {};
export default config;
